const BaseLabel: React.FC<{
  id: string;
  className?: string;
  text: string;
}> = ({ id, className, text }) => {
  return (
    <label htmlFor={id} className={`control ${className ? className : ""}`}>
      {text}
    </label>
  );
};
export default BaseLabel;
